import { Icon, Text } from '@ui/themed';
import { t } from 'i18next';
import type { IconName } from '../../../components/ui/icon/types';
import type { I18nPrefix } from '../../../i18n/prefix';
import type { PaymentMethodName } from '../types/spark-options';
import { normalizePaymentMethodsOrder } from '../utils/payment-methods';
import { SortableList } from './sortable-list';

const METHODS =
  'features:storefront_options.components.payment_methods_order_editor.methods' satisfies I18nPrefix;

const PAYMENT_METHODS = {
  upfrontPayment: { icon: 'payment', labelKey: 'upfront_payment' },
  quote: { icon: 'document', labelKey: 'quote' },
  paymentOnAccount: { icon: 'priceList', labelKey: 'payment_on_account' },
  paymentByInvoice: { icon: 'priceList', labelKey: 'payment_by_invoice' },
} as const satisfies Record<PaymentMethodName, { icon: IconName; labelKey: string }>;

function methodLabel(name: PaymentMethodName): string {
  return t(`${METHODS}.${PAYMENT_METHODS[name].labelKey}`);
}

export function PaymentMethodsOrderEditor({
  values,
  onChange,
}: {
  values: PaymentMethodName[];
  onChange: (values: PaymentMethodName[]) => void;
}) {
  const orderedValues = normalizePaymentMethodsOrder(values);

  return (
    <SortableList
      items={orderedValues}
      getKey={(name) => name}
      onReorder={onChange}
      dragActivation="row"
      renderItem={(name) => (
        <div className="flex items-center gap-2">
          <Icon name={PAYMENT_METHODS[name].icon} size="md" />
          <Text>{methodLabel(name)}</Text>
        </div>
      )}
    />
  );
}
